import { render, staticRenderFns } from "./ViewCriticismAndInternalNotesModal.vue?vue&type=template&id=d616b172&"
import script from "./ViewCriticismAndInternalNotesModal.vue?vue&type=script&lang=js&"
export * from "./ViewCriticismAndInternalNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports